import { createSlice } from "@reduxjs/toolkit";

export const apiHelpSlice = createSlice({
  name: "apiHelpSlice",
  initialState: {
    activeApi: "get_workflow",
  },
  reducers: {
    setActiveApi: (state, action) => {
      state.activeApi = action.payload;
    },
  },
});
export const apiActions = {
  ...apiHelpSlice.actions,
};

export default apiHelpSlice.reducer;
